export automaticSending from './automatic-sending/triggers';
export message from './message/triggers';
export emailTemplate from './template/triggers';
export emailPropertyData from './property-data/triggers';



// WEBPACK FOOTER //
// ./src/frontend/modules/email/triggers.js